import { createSelector } from "@reduxjs/toolkit";

const selectHapIdDataHapId = (state) => state.linkApplication?.hapIdData?.hapId;
const selectHapIdDataDateOfBirth = (state) =>
  state.linkApplication?.hapIdData?.dateOfBirth;
const selectSearchForHapIdDataFirstName = (state) =>
  state.linkApplication?.searchForHapIdData?.firstName;
const selectSearchForHapIdDataLastName = (state) =>
  state.linkApplication?.searchForHapIdData?.lastName;
const selectSearchForHapIdDataDateOfBirth = (state) =>
  state.linkApplication?.searchForHapIdData?.dateOfBirth;
const selectSearchForHapIdDataSexCode = (state) =>
  state.linkApplication?.searchForHapIdData?.sexCode;
const selectSearchForHapIdDataZipCode = (state) =>
  state.linkApplication?.searchForHapIdData?.zipCode;
const selectResponseDataHapId = (state) =>
  state.linkApplication?.responseData?.hapId;
const selectResponseDataFirstName = (state) =>
  state.linkApplication?.responseData?.firstName;
const selectResponseDataLastName = (state) =>
  state.linkApplication?.responseData?.lastName;

export const manageLinkApplicationSelector = createSelector(
  [
    selectHapIdDataHapId,
    selectHapIdDataDateOfBirth,
    selectSearchForHapIdDataFirstName,
    selectSearchForHapIdDataLastName,
    selectSearchForHapIdDataDateOfBirth,
    selectSearchForHapIdDataSexCode,
    selectSearchForHapIdDataZipCode,
    selectResponseDataHapId,
    selectResponseDataFirstName,
    selectResponseDataLastName,
  ],
  (
    hapIdDataHapId,
    hapIdDataDateOfBirth,
    searchForHapIdDataFirstName,
    searchForHapIdDataLastName,
    searchForHapIdDataDateOfBirth,
    searchForHapIdDataSexCode,
    searchForHapIdDataZipCode,
    responseDataHapId,
    responseDataFirstName,
    responseDataLastName
  ) => ({
    hapIdDataHapId,
    hapIdDataDateOfBirth,
    searchForHapIdDataFirstName,
    searchForHapIdDataLastName,
    searchForHapIdDataDateOfBirth,
    searchForHapIdDataSexCode,
    searchForHapIdDataZipCode,
    responseDataHapId,
    responseDataFirstName,
    responseDataLastName,
  })
);
